// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { SensorConfiguration, ISensorConfiguration } from "./SensorConfiguration.gen";
import { Target, ITarget } from "./Target.gen";
import { DeviceNote, IDeviceNote } from "./DeviceNote.gen";
import { Vector2, IVector2 } from "./System.Numerics.Vector2.gen";
import { DriverOverrideState, IDriverOverrideState } from "./Shared.Models.Api.V1.DriverOverrideState.gen";
import { RadarConfiguration, IRadarConfiguration } from "./RadarConfiguration.gen";
import { DeviceType } from "./Shared.DeviceType.gen";
import { SensorType } from "./Shared.SensorType.gen";
import { OperationMode } from "./Shared.OperationMode.gen";
import { MountedOnType } from "./Shared.MountedOnType.gen";
import { LogLevel } from "./Microsoft.Extensions.Logging.LogLevel.gen";
import { DeviceStatus } from "./DeviceStatus.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IDevice {
	facilityName: string | undefined;

	sensorConfig: ISensorConfiguration | undefined | IRadarConfiguration;

	activeTargets: ITarget[] | undefined;

	notes: IDeviceNote[] | undefined;

	typeAsString: string | undefined;

	statusDateAsString: string | undefined;

	hasPendingDeviceCommands: boolean | undefined;

	cameraAoiPoints: IVector2[] | undefined;

	homographySourcePoints: IVector2[] | undefined;

	homographyDestinationPoints: IVector2[] | undefined;

	boundaryPoints: IVector2[] | undefined;

	lastModifiedBy: string | undefined;

	lastModified: string | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	type: DeviceType;

	sensorType: SensorType;

	mode: OperationMode;

	dateAllocated: string | undefined;

	serialNumber: string | undefined;

	simIccid: string | undefined;

	simOperator: string | undefined;

	hardwareVersion: number | undefined;

	isDeleted: boolean;

	deviceKey: string;

	name: string;

	description: string | undefined;

	color: string | undefined;

	enableWebRtc: boolean;

	enableDhcp: boolean;

	macAddress: string | undefined;

	ipv4Address: string | undefined;

	gatewayAddresses: string | undefined;

	dnsServers: string | undefined;

	ntpServers: string | undefined;

	proxyIpAddress: string | undefined;

	port: number;

	firmwareVersion: string | undefined;

	settingsRevision: number;

	reportedSettingsRevision: number | undefined;

	sensorFirmwareVersion: string | undefined;

	positionX: number;

	positionY: number;

	height: number;

	mountedOn: MountedOnType | undefined;

	fusionOffsetRoll: number | undefined;

	fusionOffsetPitch: number | undefined;

	fusionOffsetYaw: number | undefined;

	fusionEstimatedReturnHeight: number | undefined;

	headingDegrees: number;

	desiredTiltDegrees: number;

	takeTargetPhotos: boolean;

	minSecondsBetweenPhotos: number | undefined;

	historyPerSecond: number | undefined;

	offlineMode: boolean;

	alwaysStreamBinaryData: boolean;

	streamBinaryDestinationIp: string | undefined;

	streamBinaryDestinationPort: number | undefined;

	enableDvrRecording: boolean;

	dvrFps: number;

	dvrResolutionX: number;

	dvrResolutionY: number;

	dvrBoundingBoxes: boolean;

	dvrBitrateBps: number;

	dvrRetentionHours: number;

	alwaysStreamVideo: boolean;

	videoFps: number;

	videoResolutionX: number;

	videoResolutionY: number;

	videoBoundingBoxes: boolean;

	videoBitrateBps: number;

	photoPNG: boolean | undefined;

	jpgQuality: number | undefined;

	accelerometerOffsetX: number | undefined;

	accelerometerOffsetY: number | undefined;

	accelerometerOffsetZ: number | undefined;

	accelerometerScaleX: number | undefined;

	accelerometerScaleY: number | undefined;

	accelerometerScaleZ: number | undefined;

	accelerometerMountingPhaseDegrees: number | undefined;

	inferrenceFps: number;

	snapshotResolutionX: number;

	snapshotResolutionY: number;

	secondsBetweenHeartbeat: number;

	logRetentionDays: number | undefined;

	logRetentionLevel: LogLevel | undefined;

	dataRetentionDays: number | undefined;

	targetPhotoRetentionDays: number | undefined;

	maxMinutesBetweenTargets: number | undefined;

	devicePhotoUpdateIntervalMinutes: number | undefined;

	laneCollectionStartedAt: string | undefined;

	laneCollectionUntil: string | undefined;

	laneCollectionNotifiedUntil: string | undefined;

	lastHeartbeat: string | undefined;

	lastHeartbeatLatencyMs: number;

	driverOverrideState: IDriverOverrideState | undefined;

	lastPortForwardingCheck: string | undefined;

	devicePhotoUrl: string | undefined;

	statusMessage: string | undefined;

	lastStatusChange: string | undefined;

	status: DeviceStatus;

	$type?: string | undefined;
}
export class Device {
	constructor(data?: IDevice) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.sensorConfig && data.sensorConfig.$type === RadarConfiguration.$type) { this.sensorConfig = new RadarConfiguration(data.sensorConfig as IRadarConfiguration); } else
		if (data.sensorConfig) { this.sensorConfig = new SensorConfiguration(data.sensorConfig); }
		this.activeTargets = data.activeTargets ? data.activeTargets.map((a: any) => new Target(a)) : [];
		this.notes = data.notes ? data.notes.map((n: any) => new DeviceNote(n)) : [];
		this.cameraAoiPoints = data.cameraAoiPoints ? data.cameraAoiPoints.map((c: any) => new Vector2(c)) : [];
		this.homographySourcePoints = data.homographySourcePoints ? data.homographySourcePoints.map((h: any) => new Vector2(h)) : [];
		this.homographyDestinationPoints = data.homographyDestinationPoints ? data.homographyDestinationPoints.map((h: any) => new Vector2(h)) : [];
		this.boundaryPoints = data.boundaryPoints ? data.boundaryPoints.map((b: any) => new Vector2(b)) : [];
		if (data.lastModified) { this.lastModified = new Date(data.lastModified); }
		if (data.dateAllocated) { this.dateAllocated = new Date(data.dateAllocated); }
		if (data.laneCollectionStartedAt) { this.laneCollectionStartedAt = new Date(data.laneCollectionStartedAt); }
		if (data.laneCollectionUntil) { this.laneCollectionUntil = new Date(data.laneCollectionUntil); }
		if (data.laneCollectionNotifiedUntil) { this.laneCollectionNotifiedUntil = new Date(data.laneCollectionNotifiedUntil); }
		if (data.lastHeartbeat) { this.lastHeartbeat = new Date(data.lastHeartbeat); }
		if (data.driverOverrideState) { this.driverOverrideState = new DriverOverrideState(data.driverOverrideState); }
		if (data.lastPortForwardingCheck) { this.lastPortForwardingCheck = new Date(data.lastPortForwardingCheck); }
		if (data.lastStatusChange) { this.lastStatusChange = new Date(data.lastStatusChange); }
	}

	facilityName: string | undefined;

	sensorConfig: SensorConfiguration | undefined | RadarConfiguration;

	activeTargets: Target[] | undefined = [];

	notes: DeviceNote[] | undefined = [];

	typeAsString: string | undefined;

	statusDateAsString: string | undefined;

	hasPendingDeviceCommands: boolean | undefined;

	cameraAoiPoints: Vector2[] | undefined = [];

	homographySourcePoints: Vector2[] | undefined = [];

	homographyDestinationPoints: Vector2[] | undefined = [];

	boundaryPoints: Vector2[] | undefined = [];

	lastModifiedBy: string | undefined;

	lastModified: Date | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	type: DeviceType = 0;

	sensorType: SensorType = 0;

	mode: OperationMode = 0;

	dateAllocated: Date | undefined;

	serialNumber: string | undefined;

	simIccid: string | undefined;

	simOperator: string | undefined;

	hardwareVersion: number | undefined;

	isDeleted: boolean = false;

	@IsNotEmpty()
	deviceKey: string = "";

	@IsNotEmpty()
	name: string = "";

	description: string | undefined;

	color: string | undefined;

	enableWebRtc: boolean = false;

	enableDhcp: boolean = false;

	macAddress: string | undefined;

	ipv4Address: string | undefined;

	gatewayAddresses: string | undefined;

	dnsServers: string | undefined;

	ntpServers: string | undefined;

	proxyIpAddress: string | undefined;

	port: number = 0;

	firmwareVersion: string | undefined;

	settingsRevision: number = 0;

	reportedSettingsRevision: number | undefined;

	sensorFirmwareVersion: string | undefined;

	positionX: number = 0;

	positionY: number = 0;

	height: number = 0;

	mountedOn: MountedOnType | undefined;

	fusionOffsetRoll: number | undefined;

	fusionOffsetPitch: number | undefined;

	fusionOffsetYaw: number | undefined;

	fusionEstimatedReturnHeight: number | undefined;

	headingDegrees: number = 0;

	desiredTiltDegrees: number = 0;

	takeTargetPhotos: boolean = false;

	minSecondsBetweenPhotos: number | undefined;

	historyPerSecond: number | undefined;

	offlineMode: boolean = false;

	alwaysStreamBinaryData: boolean = false;

	streamBinaryDestinationIp: string | undefined;

	streamBinaryDestinationPort: number | undefined;

	enableDvrRecording: boolean = false;

	dvrFps: number = 0;

	dvrResolutionX: number = 0;

	dvrResolutionY: number = 0;

	dvrBoundingBoxes: boolean = false;

	dvrBitrateBps: number = 0;

	dvrRetentionHours: number = 0;

	alwaysStreamVideo: boolean = false;

	videoFps: number = 0;

	videoResolutionX: number = 0;

	videoResolutionY: number = 0;

	videoBoundingBoxes: boolean = false;

	videoBitrateBps: number = 0;

	photoPNG: boolean | undefined;

	jpgQuality: number | undefined;

	accelerometerOffsetX: number | undefined;

	accelerometerOffsetY: number | undefined;

	accelerometerOffsetZ: number | undefined;

	accelerometerScaleX: number | undefined;

	accelerometerScaleY: number | undefined;

	accelerometerScaleZ: number | undefined;

	accelerometerMountingPhaseDegrees: number | undefined;

	inferrenceFps: number = 0;

	snapshotResolutionX: number = 0;

	snapshotResolutionY: number = 0;

	secondsBetweenHeartbeat: number = 0;

	logRetentionDays: number | undefined;

	logRetentionLevel: LogLevel | undefined;

	dataRetentionDays: number | undefined;

	targetPhotoRetentionDays: number | undefined;

	maxMinutesBetweenTargets: number | undefined;

	devicePhotoUpdateIntervalMinutes: number | undefined;

	laneCollectionStartedAt: Date | undefined;

	laneCollectionUntil: Date | undefined;

	laneCollectionNotifiedUntil: Date | undefined;

	lastHeartbeat: Date | undefined = new Date();

	lastHeartbeatLatencyMs: number = 0;

	driverOverrideState: DriverOverrideState | undefined;

	lastPortForwardingCheck: Date | undefined;

	devicePhotoUrl: string | undefined;

	statusMessage: string | undefined;

	lastStatusChange: Date | undefined = new Date();

	status: DeviceStatus = 0;

	static $type: string = "CoreApi.Models.Device, ";
	$type?: string | undefined = Device.$type;
}

